import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { debounce } from 'lodash';
import classnames from 'classnames';
import Select from 'react-select';
import { isEmail } from 'validator';

import firebase from '../../firebase';
import { texts } from '../../config';

const db = firebase.firestore();
const tenantsRef = db.collection('tenants');
const defaultState = {
  uid: undefined,
  name: '',
  email: '',
  role: 'admin',
  validations: {},
  isValidating: false,
  isSubmitting: false,
};
// TODO: config等に移動
const roles = ['admin', 'superStaff', 'staff'];
const { entries } = Object;

export default class UserFormModal extends Component {
  constructor() {
    super();
    this.state = { ...defaultState };
  }
  componentDidUpdate(prevProps, prevState) {
    if(!prevProps.isOpen && this.props.isOpen) {
      this.clear();
      this.setValues();
    }
  }
  clear() {
    this.setState({ ...defaultState });
  }
  setValues() {
    const { values } = this.props;
    this.setState({ ...values });
    entries(values || {}).forEach(([k, v]) => setTimeout(() => this.validate(k, v), 0));
  }
  validate = (propName, value) => {
    const { validations } = this.state;
    switch (propName) {
      case 'name': 
        this.setState({ validations: { ...validations, name: !!value } });
        break;
      case 'email': 
        this.setState({ validations: { ...validations, email: isEmail(value) } });
        break;
      case 'role': 
        this.setState({ validations: { ...validations, role: !!value } });
        break;
      default:
    }
  }
  validationCss(name) {
    const { validations: { [name]: isValid } } = this.state;
    return classnames({ 'is-valid': isValid, 'is-invalid': isValid === false });
  }
  onChange = (name, { target: { value } }) => {
    this.validate(name, value);
    this.setState({ [name]: value });
  }
  onChangeRole = ({ value } ) => {
    this.validate('role', value);
    this.setState({ 'role': value });
  }
  onSubmit = (event) => {
    event.preventDefault();
    if(this.isUnsubmittable()) return;
    const { onSubmit } = this.props;
    const { uid, name, email, role } = this.state;
    this.setState({ isSubmitting: true });
    onSubmit({ uid, name, email, role });
  }
  isUnsubmittable() {
    const { isValidating, isSubmitting, validations } = this.state;
    return isSubmitting || isValidating || !validations.name || !validations.email || !validations.role;
  }
  render() {
    const { isOpen, onClickClose } = this.props;
    const { name, email, role } = this.state;
    const roleOptions = roles.map(_ => ({ label: texts[_], value: _ }));
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>
          新規ユーザー
        </ModalHeader>
        <Form onSubmit={this.onSubmit}>
          <ModalBody>
            <FormGroup>
              <Label>ユーザー名</Label>
              <Input value={name} onChange={this.onChange.bind(this, 'name')} className={this.validationCss('name')}/>
            </FormGroup>
            <FormGroup>
              <Label>メールアドレス</Label>
              <Input value={email} onChange={this.onChange.bind(this, 'email')} className={this.validationCss('email')}/>
            </FormGroup>
            <FormGroup>
              <Label>権限</Label>
              <Select
                value={roleOptions.find(_ => _.value === role)}
                onChange={this.onChangeRole}
                options={roleOptions}
                isClearable={false}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={onClickClose}>Cancel</Button>
            <Button type="submit" color="primary" onClick={this.onSubmit} disabled={this.isUnsubmittable()}>保存</Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
};

